import { api } from "../api";

/**
 * findAllVehiclesByDepartmentIdCrudResponse - Function that finds on database all vehicles by department id as crud response  
 * /vehicles/{customerId}/{secretaryId}/{departmentId}/{status}    
 * method GET 
 * @async-function
 */
const findAllVehiclesByDepartmentIdCrudResponse = async (token: string, customerId: number, departmentId: number, status: string, page: number, size: number, ignoreDepartments: boolean = false,  search: string = "") => {
    const response = await api.get(
        `/vehicles/${customerId}/${departmentId}/${status}?page=${page}&size=${size}&ignoreDepartments=${ignoreDepartments}&search=${search}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllVehiclesByDepartmentIdCrudResponse;